//==============================
export const STATUS_OK = 200
export const SESSION_EXPIRED = "12"
export const REQUIRED_FIELD = "3"
export const INSUFFICIENT_BALANCE = "6"
export const REQUEST_ANOTHER_OTP = "211"